// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Team-module__font-s-10___AFN2i {
  font-size: 10px !important;
}

.Team-module__font-s-12___x4JBX {
  font-size: 12px !important;
}

.Team-module__font-s-13___wRXVH {
  font-size: 13px !important;
}

.Team-module__font-s-14___xJy7b {
  font-size: 14px !important;
}

.Team-module__font-s-15___Ti7Xq {
  font-size: 15px !important;
}

.Team-module__font-s-16___GFqvG {
  font-size: 16px !important;
}

.Team-module__font-s-18___PPOde {
  font-size: 18px !important;
}

.Team-module__font-s-20___V6tOZ {
  font-size: 20px !important;
}

.Team-module__font-s-22___JoNRe {
  font-size: 22px !important;
}

.Team-module__font-s-28___F9u6L {
  font-size: 28px !important;
}

.Team-module__font-w-400___LSvwB {
  font-weight: 400 !important;
}

.Team-module__font-w-500___dM20A {
  font-weight: 500 !important;
}

.Team-module__font-w-600___ZpC9K {
  font-weight: 600 !important;
}

.Team-module__font-w-700___A7oHS {
  font-weight: 700 !important;
}

.Team-module__p-5___zzTxy {
  padding: 5px !important;
}

.Team-module__p-12___UucBP {
  padding: 12px !important;
}

.Team-module__p-16___H5f35 {
  padding: 16px !important;
}

.Team-module__p-30___FUwVM {
  padding: 30px !important;
}

.Team-module__p-b-0___e7BdH {
  padding-bottom: 0 !important;
}

.Team-module__p-b-5___ghRtG {
  padding-bottom: 5px !important;
}

.Team-module__p-b-10___ajMgH {
  padding-bottom: 10px !important;
}

.Team-module__p-b-12___JvcP2 {
  padding-bottom: 12px !important;
}

.Team-module__p-b-16___OmDHo {
  padding-bottom: 16px !important;
}

.Team-module__p-b-18___nEICe {
  padding-bottom: 18px !important;
}

.Team-module__p-b-20___Ck9YS {
  padding-bottom: 20px !important;
}

.Team-module__p-b-25___IJfyC {
  padding-bottom: 25px !important;
}

.Team-module__p-b-30___sHW6b {
  padding-bottom: 30px !important;
}

.Team-module__p-b-50___X4cSA {
  padding-bottom: 50px !important;
}

.Team-module__p-t-0___M02pE {
  padding-top: 0 !important;
}

.Team-module__p-t-12___vvjpM {
  padding-top: 12px !important;
}

.Team-module__p-t-16___ap2xI {
  padding-top: 16px !important;
}

.Team-module__p-t-18___JXUBY {
  padding-top: 18px !important;
}

.Team-module__p-t-20___gNTat {
  padding-top: 20px !important;
}

.Team-module__p-t-30___STuem {
  padding-top: 30px !important;
}

.Team-module__p-t-40___Bk3Vo {
  padding-top: 40px !important;
}

.Team-module__p-t-50___bu4pJ {
  padding-top: 50px !important;
}

.Team-module__p-l-20___cEsQh {
  padding-left: 20px !important;
}

.Team-module__p-l-30____BbFl {
  padding-left: 30px !important;
}

.Team-module__p-l-40___SSYNy {
  padding-left: 40px !important;
}

.Team-module__p-r-16___JRfgz {
  padding-right: 16px !important;
}

.Team-module__p-r-20___DMVX1 {
  padding-right: 20px !important;
}

.Team-module__p-r-30___FsV3o {
  padding-right: 30px !important;
}

.Team-module__p-r-50___oZwe4 {
  padding-right: 50px !important;
}

.Team-module__p-r-60___GKsTn {
  padding-right: 60px !important;
}

.Team-module__m-b-1___y_gUO {
  margin-bottom: 1px !important;
}

.Team-module__m-b-2___w1BBJ {
  margin-bottom: 2px !important;
}

.Team-module__m-b-6___e3Bzk {
  margin-bottom: 6px !important;
}

.Team-module__m-b-8___Opu8M {
  margin-bottom: 8px !important;
}

.Team-module__m-b-10___UJeRv {
  margin-bottom: 10px !important;
}

.Team-module__m-b-14___xpwF5 {
  margin-bottom: 14px !important;
}

.Team-module__m-b-16___F_S85 {
  margin-bottom: 16px !important;
}

.Team-module__m-b-20___DpePn {
  margin-bottom: 20px !important;
}

.Team-module__m-b-22___z3qEX {
  margin-bottom: 22px !important;
}

.Team-module__m-b-24___knc_9 {
  margin-bottom: 24px !important;
}

.Team-module__m-b-30___vp12a {
  margin-bottom: 30px !important;
}

.Team-module__m-b-32___F3gaR {
  margin-bottom: 32px !important;
}

.Team-module__m-b-40___Q3aLU {
  margin-bottom: 40px !important;
}

.Team-module__m-t-2___dygxb {
  margin-top: 2px !important;
}

.Team-module__m-t-3___oa4GG {
  margin-top: 3px !important;
}

.Team-module__m-t-4___s7D6k {
  margin-top: 4px !important;
}

.Team-module__m-t-5___VHvPQ {
  margin-top: 5px !important;
}

.Team-module__m-t-8___XjElc {
  margin-top: 8px !important;
}

.Team-module__m-t-10___WlA6f {
  margin-top: 10px !important;
}

.Team-module__m-t-15___V6PG6 {
  margin-top: 15px !important;
}

.Team-module__m-t-16___yG4PS {
  margin-top: 16px !important;
}

.Team-module__m-t-20___q8Q6C {
  margin-top: 20px !important;
}

.Team-module__m-t-22___XqYvi {
  margin-top: 22px !important;
}

.Team-module__m-t-30___cyA1h {
  margin-top: 30px !important;
}

.Team-module__m-t-32___AAJZ2 {
  margin-top: 32px !important;
}

.Team-module__m-l-auto___pZprw {
  margin-left: auto !important;
}

.Team-module__m-l-4___cRFY7 {
  margin-left: 4px !important;
}

.Team-module__m-l-5___k0ges {
  margin-left: 5px !important;
}

.Team-module__m-l-6___qbO1I {
  margin-left: 6px !important;
}

.Team-module__m-l-8___c_jps {
  margin-left: 8px !important;
}

.Team-module__m-l-10___NQp5L {
  margin-left: 10px !important;
}

.Team-module__m-l-16___UQ1CH {
  margin-left: 16px !important;
}

.Team-module__m-l-20___WZOBe {
  margin-left: 20px !important;
}

.Team-module__m-l-24___iX5QZ {
  margin-left: 24px !important;
}

.Team-module__m-l-30___e4W60 {
  margin-left: 30px !important;
}

.Team-module__m-l-35___F7gyY {
  margin-left: 35px !important;
}

.Team-module__m-l-40___cVfNF {
  margin-left: 40px !important;
}

.Team-module__m-r-8___LWT05 {
  margin-right: 8px !important;
}

.Team-module__m-r-10___dXaBM {
  margin-right: 10px !important;
}

.Team-module__m-r-16___ZQ8WC {
  margin-right: 16px !important;
}

.Team-module__m-r-20___BHGk4 {
  margin-right: 20px !important;
}

.Team-module__m-r-24___cR5GR {
  margin-right: 24px !important;
}

.Team-module__m-r-30___s73ny {
  margin-right: 30px !important;
}

.Team-module__m-r-40___uDPrp {
  margin-right: 40px !important;
}

.Team-module__border-r-3___ek7sw {
  border-radius: 3px !important;
}

.Team-module__border-r-4___AcFYW {
  border-radius: 4px !important;
}

.Team-module__border-r-6___nWFNv {
  border-radius: 6px !important;
}

.Team-module__border-r-10___Fl9LN {
  border-radius: 10px !important;
}

.Team-module__border-r-12___pFgHg {
  border-radius: 12px !important;
}

.Team-module__border-r-16___nUkIu {
  border-radius: 16px !important;
}

.Team-module__border-r-50___GlZxv {
  border-radius: 50% !important;
}

.Team-module__primary-border___SKcH_ {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Team-module__primary-border-b___XjLqD {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Team-module__primary-border-t___UEQj_ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Team-module__primary-border-l___Ai0jH {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Team-module__primary-border-r___kHG9l {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Team-module__secondary-border___q70hW {
  border: 1px solid #637768;
}

.Team-module__secondary-border-b___GqZbI {
  border-bottom: 1px solid #637768;
}

.Team-module__secondary-border-t___qg8Zj {
  border-top: 1px solid #637768;
}

.Team-module__secondary-border-l___sESZm {
  border-left: 1px solid #637768;
}

.Team-module__secondary-border-r___VmmwC {
  border-right: 1px solid #637768;
}

.Team-module__gap-0___xyoe8 {
  gap: 0 !important;
}

.Team-module__gap-2___PCkGW {
  gap: 2px !important;
}

.Team-module__gap-4___fMsGt {
  gap: 4px !important;
}

.Team-module__gap-5___iCVne {
  gap: 5px !important;
}

.Team-module__gap-6___cModG {
  gap: 6px !important;
}

.Team-module__gap-8___l__oi {
  gap: 8px !important;
}

.Team-module__gap-10___VHYJu {
  gap: 10px !important;
}

.Team-module__gap-12___jkImd {
  gap: 12px !important;
}

.Team-module__gap-14___FPU6T {
  gap: 14px !important;
}

.Team-module__gap-16___JkxtY {
  gap: 16px !important;
}

.Team-module__gap-18___ZOxXf {
  gap: 18px !important;
}

.Team-module__gap-20___N9Vz9 {
  gap: 20px !important;
}

.Team-module__gap-24___QaKAq {
  gap: 24px !important;
}

.Team-module__gap-26___y2OBq {
  gap: 26px !important;
}

.Team-module__gap-30___Mm9o9 {
  gap: 30px !important;
}

.Team-module__gap-32___snmv2 {
  gap: 32px !important;
}

.Team-module__gap-40___eCrwh {
  gap: 40px !important;
}

.Team-module__gap-50___WvxnK {
  gap: 50px !important;
}

.Team-module__flex-1___y94MI {
  flex: 1;
}

.Team-module__flex-none___Mw_GD {
  flex: none !important;
}

.Team-module__flex-column___BfHtp {
  display: flex;
  flex-direction: column !important;
}

.Team-module__flex-row___uE4l4 {
  display: flex;
  flex-direction: row !important;
}

.Team-module__vertically-centered___YESp3 {
  display: flex;
  align-items: center !important;
}

.Team-module__horizontally-centered___U1dDx {
  display: flex;
  justify-content: center !important;
}

.Team-module__horizontally-end___V7sSU {
  display: flex;
  justify-content: end !important;
}

.Team-module__vertically-start___pPLas {
  display: flex;
  align-items: start !important;
}

.Team-module__space-between___C1sZj {
  display: flex;
  justify-content: space-between !important;
}

.Team-module__flex-wrap___z8OPV {
  flex-wrap: wrap !important;
}

.Team-module__height-100___owONH {
  height: 100%;
}

.Team-module__width-50___Ea6pn {
  width: 50% !important;
}

.Team-module__width-100___ynxGd {
  width: 100%;
}

.Team-module__cursor-pointer___SVa1Y {
  cursor: pointer;
}

.Team-module__cursor-not-allowed___pWWqg {
  cursor: not-allowed !important;
}

.Team-module__absolute-centered___dpihI {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Team-module__absolute___osJt2 {
  position: absolute;
}

.Team-module__relative___Ll5Vt {
  position: relative;
}

.Team-module__fixed___XRBew {
  position: fixed;
}

.Team-module__visible___Cmzqe {
  opacity: 1;
}

.Team-module__invisible___SrVAo {
  opacity: 0;
}

.Team-module__col-90___pwGiA {
  width: 90% !important;
}

.Team-module__col-auto___wdYoh {
  width: auto !important;
}

.Team-module__medical-tabs___NJPMd {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Team-module__medical-table-new___vuwBa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Team-module__medical-table-new___vuwBa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Team-module__medical-table-new___vuwBa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Team-module__medical-table-new___vuwBa::-webkit-scrollbar-track {
  display: none;
}
.Team-module__medical-table-new___vuwBa.Team-module__no-pagination___TixWC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Team-module__medical-table-new___vuwBa.Team-module__no-pagination___TixWC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Team-module__medical-table-new___vuwBa.Team-module__no-pagination___TixWC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Team-module__medical-table-new___vuwBa.Team-module__no-pagination___TixWC::-webkit-scrollbar-track {
  display: none;
}

.Team-module__medical-table-empty___cHEMh {
  padding: 14px 40px !important;
}

.Team-module__icon-btn___FJ2t2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Team-module__search-icon___EjFUY {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Team-module__disable-select____WFtq {
  user-select: none;
}

.Team-module__break-word___oeykx {
  word-break: break-word;
}

.Team-module__popup-clear-btn___eTGXO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Team-module__scroll-m-b-20___o4tSP {
  scroll-margin-bottom: 20px;
}

.Team-module__article___S3uzy {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Team-module__article___S3uzy:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Team-module__article___S3uzy::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Team-module__article___S3uzy::-webkit-scrollbar-track {
  display: none;
}
.Team-module__article___S3uzy .Team-module__wrapper___yeaBc {
  width: 60%;
  margin: 27px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Team/Team.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECQE,2GDNE;ECOF,kBAAA;EACA,kBAAA;ADupBF;ACrpBE;EACE,oCAAA;EACA,mBAAA;ADupBJ;ACppBE;EACE,UAAA;EACA,6BAAA;ADspBJ;ACnpBE;EACE,aAAA;ADqpBJ;AArqBE;EACE,UAAA;EACA,YAAA;AAuqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.article {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n\n  .wrapper {\n    width: 60%;\n    margin: 27px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Team-module__font-s-10___AFN2i`,
	"fontS12": `Team-module__font-s-12___x4JBX`,
	"fontS13": `Team-module__font-s-13___wRXVH`,
	"fontS14": `Team-module__font-s-14___xJy7b`,
	"fontS15": `Team-module__font-s-15___Ti7Xq`,
	"fontS16": `Team-module__font-s-16___GFqvG`,
	"fontS18": `Team-module__font-s-18___PPOde`,
	"fontS20": `Team-module__font-s-20___V6tOZ`,
	"fontS22": `Team-module__font-s-22___JoNRe`,
	"fontS28": `Team-module__font-s-28___F9u6L`,
	"fontW400": `Team-module__font-w-400___LSvwB`,
	"fontW500": `Team-module__font-w-500___dM20A`,
	"fontW600": `Team-module__font-w-600___ZpC9K`,
	"fontW700": `Team-module__font-w-700___A7oHS`,
	"p5": `Team-module__p-5___zzTxy`,
	"p12": `Team-module__p-12___UucBP`,
	"p16": `Team-module__p-16___H5f35`,
	"p30": `Team-module__p-30___FUwVM`,
	"pB0": `Team-module__p-b-0___e7BdH`,
	"pB5": `Team-module__p-b-5___ghRtG`,
	"pB10": `Team-module__p-b-10___ajMgH`,
	"pB12": `Team-module__p-b-12___JvcP2`,
	"pB16": `Team-module__p-b-16___OmDHo`,
	"pB18": `Team-module__p-b-18___nEICe`,
	"pB20": `Team-module__p-b-20___Ck9YS`,
	"pB25": `Team-module__p-b-25___IJfyC`,
	"pB30": `Team-module__p-b-30___sHW6b`,
	"pB50": `Team-module__p-b-50___X4cSA`,
	"pT0": `Team-module__p-t-0___M02pE`,
	"pT12": `Team-module__p-t-12___vvjpM`,
	"pT16": `Team-module__p-t-16___ap2xI`,
	"pT18": `Team-module__p-t-18___JXUBY`,
	"pT20": `Team-module__p-t-20___gNTat`,
	"pT30": `Team-module__p-t-30___STuem`,
	"pT40": `Team-module__p-t-40___Bk3Vo`,
	"pT50": `Team-module__p-t-50___bu4pJ`,
	"pL20": `Team-module__p-l-20___cEsQh`,
	"pL30": `Team-module__p-l-30____BbFl`,
	"pL40": `Team-module__p-l-40___SSYNy`,
	"pR16": `Team-module__p-r-16___JRfgz`,
	"pR20": `Team-module__p-r-20___DMVX1`,
	"pR30": `Team-module__p-r-30___FsV3o`,
	"pR50": `Team-module__p-r-50___oZwe4`,
	"pR60": `Team-module__p-r-60___GKsTn`,
	"mB1": `Team-module__m-b-1___y_gUO`,
	"mB2": `Team-module__m-b-2___w1BBJ`,
	"mB6": `Team-module__m-b-6___e3Bzk`,
	"mB8": `Team-module__m-b-8___Opu8M`,
	"mB10": `Team-module__m-b-10___UJeRv`,
	"mB14": `Team-module__m-b-14___xpwF5`,
	"mB16": `Team-module__m-b-16___F_S85`,
	"mB20": `Team-module__m-b-20___DpePn`,
	"mB22": `Team-module__m-b-22___z3qEX`,
	"mB24": `Team-module__m-b-24___knc_9`,
	"mB30": `Team-module__m-b-30___vp12a`,
	"mB32": `Team-module__m-b-32___F3gaR`,
	"mB40": `Team-module__m-b-40___Q3aLU`,
	"mT2": `Team-module__m-t-2___dygxb`,
	"mT3": `Team-module__m-t-3___oa4GG`,
	"mT4": `Team-module__m-t-4___s7D6k`,
	"mT5": `Team-module__m-t-5___VHvPQ`,
	"mT8": `Team-module__m-t-8___XjElc`,
	"mT10": `Team-module__m-t-10___WlA6f`,
	"mT15": `Team-module__m-t-15___V6PG6`,
	"mT16": `Team-module__m-t-16___yG4PS`,
	"mT20": `Team-module__m-t-20___q8Q6C`,
	"mT22": `Team-module__m-t-22___XqYvi`,
	"mT30": `Team-module__m-t-30___cyA1h`,
	"mT32": `Team-module__m-t-32___AAJZ2`,
	"mLAuto": `Team-module__m-l-auto___pZprw`,
	"mL4": `Team-module__m-l-4___cRFY7`,
	"mL5": `Team-module__m-l-5___k0ges`,
	"mL6": `Team-module__m-l-6___qbO1I`,
	"mL8": `Team-module__m-l-8___c_jps`,
	"mL10": `Team-module__m-l-10___NQp5L`,
	"mL16": `Team-module__m-l-16___UQ1CH`,
	"mL20": `Team-module__m-l-20___WZOBe`,
	"mL24": `Team-module__m-l-24___iX5QZ`,
	"mL30": `Team-module__m-l-30___e4W60`,
	"mL35": `Team-module__m-l-35___F7gyY`,
	"mL40": `Team-module__m-l-40___cVfNF`,
	"mR8": `Team-module__m-r-8___LWT05`,
	"mR10": `Team-module__m-r-10___dXaBM`,
	"mR16": `Team-module__m-r-16___ZQ8WC`,
	"mR20": `Team-module__m-r-20___BHGk4`,
	"mR24": `Team-module__m-r-24___cR5GR`,
	"mR30": `Team-module__m-r-30___s73ny`,
	"mR40": `Team-module__m-r-40___uDPrp`,
	"borderR3": `Team-module__border-r-3___ek7sw`,
	"borderR4": `Team-module__border-r-4___AcFYW`,
	"borderR6": `Team-module__border-r-6___nWFNv`,
	"borderR10": `Team-module__border-r-10___Fl9LN`,
	"borderR12": `Team-module__border-r-12___pFgHg`,
	"borderR16": `Team-module__border-r-16___nUkIu`,
	"borderR50": `Team-module__border-r-50___GlZxv`,
	"primaryBorder": `Team-module__primary-border___SKcH_`,
	"primaryBorderB": `Team-module__primary-border-b___XjLqD`,
	"primaryBorderT": `Team-module__primary-border-t___UEQj_`,
	"primaryBorderL": `Team-module__primary-border-l___Ai0jH`,
	"primaryBorderR": `Team-module__primary-border-r___kHG9l`,
	"secondaryBorder": `Team-module__secondary-border___q70hW`,
	"secondaryBorderB": `Team-module__secondary-border-b___GqZbI`,
	"secondaryBorderT": `Team-module__secondary-border-t___qg8Zj`,
	"secondaryBorderL": `Team-module__secondary-border-l___sESZm`,
	"secondaryBorderR": `Team-module__secondary-border-r___VmmwC`,
	"gap0": `Team-module__gap-0___xyoe8`,
	"gap2": `Team-module__gap-2___PCkGW`,
	"gap4": `Team-module__gap-4___fMsGt`,
	"gap5": `Team-module__gap-5___iCVne`,
	"gap6": `Team-module__gap-6___cModG`,
	"gap8": `Team-module__gap-8___l__oi`,
	"gap10": `Team-module__gap-10___VHYJu`,
	"gap12": `Team-module__gap-12___jkImd`,
	"gap14": `Team-module__gap-14___FPU6T`,
	"gap16": `Team-module__gap-16___JkxtY`,
	"gap18": `Team-module__gap-18___ZOxXf`,
	"gap20": `Team-module__gap-20___N9Vz9`,
	"gap24": `Team-module__gap-24___QaKAq`,
	"gap26": `Team-module__gap-26___y2OBq`,
	"gap30": `Team-module__gap-30___Mm9o9`,
	"gap32": `Team-module__gap-32___snmv2`,
	"gap40": `Team-module__gap-40___eCrwh`,
	"gap50": `Team-module__gap-50___WvxnK`,
	"flex1": `Team-module__flex-1___y94MI`,
	"flexNone": `Team-module__flex-none___Mw_GD`,
	"flexColumn": `Team-module__flex-column___BfHtp`,
	"flexRow": `Team-module__flex-row___uE4l4`,
	"verticallyCentered": `Team-module__vertically-centered___YESp3`,
	"horizontallyCentered": `Team-module__horizontally-centered___U1dDx`,
	"horizontallyEnd": `Team-module__horizontally-end___V7sSU`,
	"verticallyStart": `Team-module__vertically-start___pPLas`,
	"spaceBetween": `Team-module__space-between___C1sZj`,
	"flexWrap": `Team-module__flex-wrap___z8OPV`,
	"height100": `Team-module__height-100___owONH`,
	"width50": `Team-module__width-50___Ea6pn`,
	"width100": `Team-module__width-100___ynxGd`,
	"cursorPointer": `Team-module__cursor-pointer___SVa1Y`,
	"cursorNotAllowed": `Team-module__cursor-not-allowed___pWWqg`,
	"absoluteCentered": `Team-module__absolute-centered___dpihI`,
	"absolute": `Team-module__absolute___osJt2`,
	"relative": `Team-module__relative___Ll5Vt`,
	"fixed": `Team-module__fixed___XRBew`,
	"visible": `Team-module__visible___Cmzqe`,
	"invisible": `Team-module__invisible___SrVAo`,
	"col90": `Team-module__col-90___pwGiA`,
	"colAuto": `Team-module__col-auto___wdYoh`,
	"medicalTabs": `Team-module__medical-tabs___NJPMd`,
	"medicalTableNew": `Team-module__medical-table-new___vuwBa`,
	"noPagination": `Team-module__no-pagination___TixWC`,
	"medicalTableEmpty": `Team-module__medical-table-empty___cHEMh`,
	"iconBtn": `Team-module__icon-btn___FJ2t2`,
	"searchIcon": `Team-module__search-icon___EjFUY`,
	"disableSelect": `Team-module__disable-select____WFtq`,
	"breakWord": `Team-module__break-word___oeykx`,
	"popupClearBtn": `Team-module__popup-clear-btn___eTGXO`,
	"scrollMB20": `Team-module__scroll-m-b-20___o4tSP`,
	"article": `Team-module__article___S3uzy`,
	"wrapper": `Team-module__wrapper___yeaBc`
};
module.exports = ___CSS_LOADER_EXPORT___;
